const checkIsTherapist = (roles: Array<String>) => {
  return roles.includes('therapist');
};

const checkIsAssistance = (roles: Array<String>) => {
  return roles.includes('assistant');
};

export const getTherapistCred = (
  discipline: string | boolean | string[] | null,
  roles: string | boolean | string[] | null
) => {
  if (typeof roles === 'string' || typeof roles === 'boolean') {
    return '';
  }

  if (!discipline || !roles || roles?.length === 0) {
    return '';
  }

  if (checkIsTherapist(roles)) {
    return discipline;
  }

  if (checkIsAssistance(roles)) {
    switch (discipline) {
      case 'PT':
        return 'PTA';
      case 'OT':
        return 'COTA';
      default:
        return '';
    }
  }

  return '';
};
